import React from "react";
import { widgetView } from "../models";
import CPSettingRadio from "../../../../UI/Settings/CPSettingRadio";
import CPSettingToggle from "../../../../UI/Settings/CPSettingToggle";
import CPSettingSize from "../../../../UI/Settings/CPSettingSize";
import CPSettingFont from "../../../../UI/Settings/CPSettingFont";
import CPSettingColor from "../../../../UI/Settings/CPSettingColor";
import CPSettingText from "../../../../UI/Settings/CPSettingText";
import CPSettingRange from "../../../../UI/Settings/CPSettingRange";
import WidgetSettingRoles from "../WidgetSettingRoles";
import WidgetLanguageSetting, { LANGUAGE } from "../../components/Settings/WidgetLanguageSetting";

const DEFAULT_VIEW_TYPE = 'allMembers';

const CommonSettings = ({ eventKey, settings, onChange }) => {
    const isAllMembersView = settings?.view === DEFAULT_VIEW_TYPE;

    return (
        <>
            <WidgetLanguageSetting
                lang={settings?.[LANGUAGE]}
                onUpdate={(key, value) => onChange({[key]: value})}
            />
            <CPSettingRadio
                name="view"
                eventValue={settings?.view}
                defaultValue="allMembers"
                label="Вид"
                options={widgetView}
                onChange={onChange}
            />
            <WidgetSettingRoles
                eventKey={eventKey}
                widgetRoles={settings?.roles ?? []}
                onChange={onChange}
            />
            {isAllMembersView
                ? <>
                    <CPSettingToggle
                        name="showTextToRight"
                        isChecked={settings?.showTextToRight}
                        label="Показывать текст справа от фотографии"
                        onChange={onChange}
                    />
                    <CPSettingToggle
                        name="showPhotoCentered"
                        isChecked={settings?.showPhotoCentered}
                        label="Выравнивать фотографии по центру"
                        onChange={onChange}
                    />
                    <CPSettingSize
                        name="membersPerPage"
                        label="Участников на странице"
                        eventValue={settings?.membersPerPage}
                        defaultValue={50}
                        isNumericalSize={true}
                        minValue={1}
                        onChange={onChange}
                    />
                    <CPSettingToggle
                        name="showMoreAccent"
                        isChecked={settings?.showMoreAccent}
                        label="Кнопка Показать ещё Акцентным цветом"
                        onChange={onChange}
                    />
                </>
                : <>
                    <CPSettingToggle
                        name="showAutoplay"
                        isChecked={settings?.showAutoplay}
                        label="Включить автопролистывание"
                        onChange={onChange}
                    />
                </>
            }
            <CPSettingFont
                font={settings?.font}
                onChange={onChange}
            />
            <CPSettingColor
                name="colorAccent"
                label="Акцентный цвет"
                eventColor={settings?.colorAccent}
                defaultColor="#FF434C"
                onChange={onChange}
            />
            <CPSettingColor
                name="backgroundColor"
                label="Цвет фона"
                eventColor={settings?.backgroundColor}
                defaultColor="#16161B"
                onChange={onChange}
            />
            <CPSettingRange
                name="backgroundOpacityPercent"
                value={settings?.backgroundOpacityPercent}
                defaultValue={settings?.backgroundOpacityPercent ?? 100}
                label="Прозрачность фона"
                step={5}
                onChange={onChange}
            />
            {/* <CPSettingSize
                name="backgroundBlurSize"
                label="Размытие фона"
                eventValue={settings?.backgroundBlurSize}
                defaultValue="0px"
                onChange={onChange}
            /> */}
            <CPSettingColor
                name="textColor"
                label="Цвет подложки"
                eventColor={settings?.textColor}
                defaultColor="#FFFFFF"
                onChange={onChange}
            />
            <CPSettingRange
                name="backgroundAdditionalOpacityPercent"
                value={settings?.backgroundAdditionalOpacityPercent}
                defaultValue={settings?.backgroundAdditionalOpacityPercent ?? 5}
                label="Прозрачность фона у подложки"
                step={5}
                onChange={onChange}
            />
            <CPSettingColor
                name="additionalColor"
                label="Цвет текста и элементов"
                eventColor={settings?.additionalColor}
                defaultColor="#16161B"
                hint="Кнопки, теги, стрелки слайдера и т.д."
                onChange={onChange}
            />
            <CPSettingColor
                name="cardTextColor"
                label="Дополнительный цвет"
                eventColor={settings?.cardTextColor}
                defaultColor="#FFFFFF"
                hint="Информация об участнике: регалии и название организации"
                onChange={onChange}
            />
            <CPSettingSize
                name="elementsRoundingSize"
                label="Скругление элементов"
                eventValue={settings?.elementsRoundingSize}
                defaultValue="4px"
                onChange={onChange}
            />
            <CPSettingSize
                name="photoRoundingSize"
                label="Скругление фотографий"
                eventValue={settings?.photoRoundingSize}
                defaultValue="8px"
                onChange={onChange}
            />
            {
                !isAllMembersView &&
                <>
                    <CPSettingToggle
                        name="showArrow"
                        isChecked={settings?.showArrow}
                        label="Показывать стрелки"
                        onChange={onChange}
                    />
                    {settings?.showArrow && (
                        <CPSettingSize
                            name="arrowRoundingSize"
                            label="Скругление кнопки со стрелкой"
                            eventValue={settings?.arrowRoundingSize}
                            defaultValue="24px"
                            onChange={onChange}
                        />
                    )}
                </>
            }
            <CPSettingToggle
                name="showTitle"
                isChecked={settings?.showTitle}
                label="Показывать заголовок"
                onChange={onChange}
            />
            {settings?.showTitle && (
                <>
                    <CPSettingText
                        eventSetting={settings}
                        title="Заголовок"
                        property="title"
                        hasToggleProperty={false}
                        defaultValue="Участники"
                        onUpdate={onChange}
                    />
                    <CPSettingSize
                        name="titleSize"
                        label="Размер заголовка"
                        eventValue={settings?.titleSize}
                        defaultValue={'24px'}
                        onChange={onChange}
                    />
                    <CPSettingColor
                        name="titleColor"
                        label="Цвет заголовка"
                        eventColor={settings?.titleColor}
                        defaultColor="#FFFFFF"
                        onChange={onChange}
                    />
                </>
            )}
            <CPSettingToggle
                name="showOrganizationFilter"
                isChecked={settings?.showOrganizationFilter}
                label="Показывать фильтр по организации"
                onChange={onChange}
            />
            <CPSettingToggle
                name="showRolesFilter"
                isChecked={settings?.showRolesFilter}
                label="Показывать фильтр по дополнительному признаку"
                onChange={onChange}
            />
            <CPSettingToggle
                name="showSearch"
                isChecked={settings?.showSearch}
                label="Показывать поиск"
                onChange={onChange}
            />
            <CPSettingToggle
                name="showTagsFilter"
                isChecked={settings?.showTagsFilter}
                label="Показывать фильтр по тегам"
                onChange={onChange}
            />
            <CPSettingToggle
                name="showBigPhotos"
                isChecked={settings?.showBigPhotos}
                label="Показывать большие фотографии"
                onChange={onChange}
            />
            <CPSettingToggle
                name="displayEpisodeRecord"
                isChecked={settings?.displayEpisodeRecord}
                label="Включить отображение записи у прошедших эпизодов"
                onChange={onChange}
            />
        </>
    );
}; 

export default CommonSettings;
